import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '../../router';
import { Wizard } from '../../common/components/wizard.component';
import { CreateEventForm } from '../../events/components/create-events-form.container';
import { TargetPickerForm } from './target-picker-form.container';
import { PublicationPlatformPickerForm } from './publication-platform-picker-form.container';
import { CreateUpdatePollForm } from '../../polls/components/create-update-poll-form.container';
import { CreateUpdateNewsForm } from '../../news/components/create-update-news-form.container';

class FeedItemWizardView extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.object.isRequired,
    }).isRequired,
  };

  getInitialStep(action) {
    if (action === 'PUBLISH') {
      return 1;
    }
    if (action === 'PLATFORMS') {
      return 2;
    }
    return 0;
  }

  getRouteData(props) {
    const splittedPath = props.location.pathname.split('/');
    return {
      type: splittedPath[2]?.toUpperCase(),
      action: splittedPath[3]?.toUpperCase(),
      editEntityId: props.match.params.id || null,
    };
  }

  render() {
    const { type, action, editEntityId } = this.getRouteData(this.props);

    const definitionsMap = {
      'SPORTS-EVENTS': {
        component: CreateEventForm,
        title: 'Create/Edit Sport Event',
        props: { editEntityId },
      },
      EVENTS: {
        component: CreateEventForm,
        title: 'Create/Edit Event',
        props: { editEntityId },
      },
      POLLS: {
        component: CreateUpdatePollForm,
        title: 'Create/Edit Polls',
        props: { editEntityId },
      },
      NEWS: {
        component: CreateUpdateNewsForm,
        title: 'Create/Edit News',
        props: { editEntityId },
      },
    };

    const primaryStep = definitionsMap[type] || definitionsMap.NEWS;

    const step = this.getInitialStep(action);
    const steps = [
      primaryStep,
      {
        component: TargetPickerForm,
        title: 'Choose Recipients',
        props: { editEntityId },
      },
      {
        component: PublicationPlatformPickerForm,
        title: 'Communication Platform',
        props: { editEntityId },
      },
    ];

    return (
      <Wizard step={step} steps={steps} />
    );
  }
}

export const FeedItemWizard = withRouter(FeedItemWizardView);
